import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSumo from './useSumo';

const useSumoTable = () => {
  const { t } = useTranslation();
  const { data = [], loading, error } = useSumo();

  // Stable columns
  const columns = useMemo(
    () => [
      { Header: t("sumo.table.columns.id"), accessor: "id" },
      { Header: t("sumo.table.columns.executionId"), accessor: "executionId" },
      { Header: t("sumo.table.columns.user"), accessor: "userName" },
      { Header: t("sumo.table.columns.createdAt"), accessor: "createdAt" },
    ],
    [t]
  );

  // Stable rows (recompute only when data changes)
  const rows = useMemo(
    () =>
      data.map((item) => ({
        id: item.id ?? t("sumo.table.unknown"),
        executionId: item.executionId ?? t("sumo.table.unknown"),
        userName: item.userName ?? t("sumo.table.unknown"),
        createdAt: item.createdAt ?? t("sumo.table.unknown"),
      })),
    [data, t]
  );

  // Stable table object identity
  const tableData = useMemo(
    () => ({ columns, rows }),
    [columns, rows]
  );

  return { tableData, loading, error };
};

export default useSumoTable;
